import React from 'react';
import { useNavigate } from 'react-router-dom';
import InputForm from '../InputForm';
import SelectForm from '../SelectForm';
import useTorneosStore from '../../store/torneosStore';
import LabelImagen from '../LabelImagen';
import SelectMultiForm from '../SelectMultiForm';
import {Sketch} from '@uiw/react-color';

const FormTorneos = () => {
    const navigate = useNavigate();
    const { datos, handleChange, handleSave, handleImagen, imagen, limpiarImagen, sucursales, handleSucursales, setHexFondo, setHexTexto, error } = useTorneosStore();
    const goBack = () => navigate(-1);

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">
            <div className="card-body p-40">
                <div className="row">
                    <div className="col-sm-12">
                        <InputForm
                            name="nombre"
                            label="Nombre Torneo"
                            datos={datos}
                            change={handleChange}
                            error={error}
                            required/>
                        <SelectMultiForm
                            col="col-sm-12"
                            datos={sucursales} 
                            change={handleSucursales}
                            values={datos.sucursales}
                            isMulti={false}
                            placeholder="Seleccione una sucursal"
                            error={error}
                            name="sucursales"
                        />
                        <InputForm
                            name="descripcion"
                            label="Descripción"
                            datos={datos}
                            change={handleChange}
                            error={error}/>
                        <InputForm
                            name="reglas"
                            label="Reglas / Detalle"
                            datos={datos}
                            change={handleChange}
                            error={error}/>
                        
                        <div className="row">
                            <SelectForm
                                col="col-sm-6"
                                name="tipoTorneo"
                                label="Tipo de participante"
                                datos={datos}
                                change={handleChange}
                                options={[
                                    { value: "individual", label: "Individual" },
                                    { value: "team", label: "Equipo / Pareja" }
                                ]}
                            />
                            <InputForm
                                col="col-sm-6"
                                name="maxJugadores"
                                label={datos.tipoTorneo === "team" ? "Máximo de equipos/parejas" : "Máximo de jugadores"}
                                type="number"
                                esNumero={true}
                                datos={datos}
                                change={handleChange}
                                error={error}
                                required
                            />
                        </div>
                        <div className="row">
                            <SelectForm
                                col="col-sm-4"
                                name="genero"
                                label="Rama"
                                datos={datos}
                                change={handleChange}
                                options={[
                                    { value: "open", label: "Abierta" },
                                    { value: "male", label: "Varonil" },
                                    { value: "female", label: "Femenil" },
                                    { value: "mixed", label: "Mixta" }
                                ]}
                            />
                            <SelectForm
                                col="col-sm-4"
                                name="formato"
                                label="Formato"
                                datos={datos}
                                change={handleChange}
                                options={[
                                    { value: "single_elimination", label: "Eliminación sencilla" },
                                    { value: "double_elimination", label: "Doble eliminación" },
                                    { value: "round_robin", label: "Round robin" },
                                    { value: "groups_knockout", label: "Grupos + eliminación" }
                                ]}
                            />
                            <SelectForm
                                col="col-sm-4"
                                name="aprobacion"
                                label="Aprobación"
                                datos={datos}
                                change={handleChange}
                                options={[
                                    { value: "automatic", label: "Automática" },
                                    { value: "manual", label: "Manual" }
                                ]}
                            />
                        </div>
                        
                        <div className="row">
                            <SelectForm
                                col="col-sm-6"
                                name="categoriaInicio"
                                label="Categoría Inicial"
                                datos={datos}
                                change={handleChange}
                                error={error}
                                required
                                options={[
                                    { value: 8, label: "Categoría 8 (Principiante)" },
                                    { value: 7, label: "Categoría 7" },
                                    { value: 6, label: "Categoría 6" },
                                    { value: 5, label: "Categoría 5" },
                                    { value: 4, label: "Categoría 4" },
                                    { value: 3, label: "Categoría 3" },
                                    { value: 2, label: "Categoría 2" },
                                    { value: 1, label: "Categoría 1 (Profesional)" }
                                ]}
                            />
                            <SelectForm
                                col="col-sm-6"
                                name="categoriaFin"
                                label="Categoría Final (Opcional)"
                                datos={datos}
                                change={handleChange}
                                error={error}
                                options={[
                                    { value: 0, label: "Ninguna (Categoría única)" },
                                    { value: 8, label: "Categoría 8 (Principiante)" },
                                    { value: 7, label: "Categoría 7" },
                                    { value: 6, label: "Categoría 6" },
                                    { value: 5, label: "Categoría 5" },
                                    { value: 4, label: "Categoría 4" },
                                    { value: 3, label: "Categoría 3" },
                                    { value: 2, label: "Categoría 2" },
                                    { value: 1, label: "Categoría 1 (Profesional)" }
                                ]}
                            />
                        </div>
                        <div className="row">
                            <InputForm
                                col="col-sm-6"
                                name="costo"
                                label="Costo"
                                type="number"
                                esNumeroConDecimales={true}
                                datos={datos}
                                change={handleChange}
                                error={error}
                            />
                            <InputForm
                                col="col-sm-6"
                                name="instruccionesPago"
                                label="Instrucciones de pago"
                                datos={datos}
                                change={handleChange}
                                error={error}
                            />
                        </div>
                        
                        <div className="row">
                            <InputForm
                                col="col-sm-6"
                                name="fechaInicio"
                                label="Fecha Inicio Torneo"
                                type="date"
                                datos={datos}
                                change={handleChange}
                                error={error}
                                required
                            />
                            <InputForm
                                col="col-sm-6"
                                name="fechaFin"
                                label="Fecha Fin Torneo"
                                type="date"
                                datos={datos}
                                change={handleChange}
                                error={error}
                                required
                            />
                        </div>

                        <div className="row">
                            <InputForm
                                col="col-sm-6"
                                name="fechaInicioInscripcion"
                                label="Inicio Inscripción"
                                type="date"
                                datos={datos}
                                change={handleChange}
                                error={error}
                                required
                            />
                            <InputForm
                                col="col-sm-6"
                                name="fechaFinInscripcion"
                                label="Fin Inscripción"
                                type="date"
                                datos={datos}
                                change={handleChange}
                                error={error}
                                required
                            />
                        </div>

                        {
                          imagen ? (
                            <LabelImagen
                              label="Imagen de Torneo"
                              value={datos.imagen || ""}
                              quitar={limpiarImagen}
                              required
                            />
                          ) : (
                            <InputForm
                              name="imagen"
                              label="Imagen de Torneo"
                              type="file"
                              accept="image/jpeg,image/png,image/webp"
                              datos={datos}
                              change={handleImagen}
                              error={error}
                            />
                          )
                        }

                        <div className='row'>
                            <div className='col-6 mb-3'>
                                <label style={{ textAlign: 'center', width: '100%' }}>Color Fondo</label>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Sketch
                                      color={datos.hexFondo}
                                      disableAlpha={true}
                                      presetColors={false}
                                      onChange={(color) => {
                                        setHexFondo(color.hex);
                                      }}
                                    />
                                </div>
                            </div>
                            <div className='col-6 mb-3'>
                                <label style={{ textAlign: 'center', width: '100%' }}>Color Texto</label>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Sketch
                                      color={datos.hexTexto}
                                      disableAlpha={true}
                                      presetColors={false}
                                      onChange={(color) => {
                                          setHexTexto(color.hex);
                                      }}
                                    />
                                </div>
                            </div>
                        </div>
                        
                        {/* <div className='col-12 d-flex justify-content-center mt-3 mb-5' >
                            <img src={datos.imagen} alt="" width={300} />
                        </div> */}

                    </div>
                </div>
                <div className="row mt-5">
                    <SelectForm
                        name='estatus'
                        label='Estatus'
                        datos={datos}
                        change={handleChange}
                        options={[
                            { value: "draft", label: "Borrador" },
                            { value: "published", label: "Publicado" },
                            { value: "in_progress", label: "En progreso" },
                            { value: "completed", label: "Completado" },
                            { value: "cancelled", label: "Cancelado" },
                        ]}
                    />
                    <div className="d-flex align-items-center justify-content-between gap-3 mt-24">
                        <button
                            onClick={goBack}
                            type="reset"
                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                        >
                            Cancelar
                        </button>
                        <button
                            // type="submit"
                            onClick={
                                () => {
                                    // setDisabledButton(true);
                                    handleSave();
                                }
                            }
                            className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                        >
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default FormTorneos;
